// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3s28p","box":"WorkspacesBox_box__2QP-B","node":"WorkspacesBox_node__WMkEg"};